/*export const validToken = {
  prodotto: 1,
  nome:"Utente",
  cognome:"Monforte",
  comuneNascita:"Milano",
  provinciaNascita:"Milano",
  dataNascita:"01/01/1980",
  nazioneNascita:"Italia",
  codiceFiscale:"MNFTNT80A01F205P",
  prodottoCRM:"1",
  sesso:"M",
  email:"u.mo.tes@monforte.it",
  telefonoFisso:"0286451339",
  telefonoCell:"3334455667",
  telefono:"3334455667",
  cap:"20145",
  exception:"",
  urlRitorno:"",
  crypto:"069074012144131181230196252105136144031199058237"
};*/

export const validToken = {
  "prodotto": 1,
  "nazioneNascita": null,
  "prodottoCRM": "1",
  "telefonoFisso": null,
  "telefono": null,
  "exception": null,
  "urlRitorno": null,
  "crypto": null,
  "codFiliale": "063",
  "Data": "2021-09-30",
  "cap": "06034",
  "telefonoCell": "3401034484",
  "codiceFiscale": "BRTCLD65A26A475D",
  "cognome": "BARTOLUCCI",
  "contactID": "0012o00002Xwr8xAAB",
  "dataNascita": "26/01/1965",
  "email": "FIORDI9SIMONA@HOTMAIL.IT",
  "comuneNascita": "ASSISI",
  "localitaResidenza": "FOLIGNO",
  "nome": "CLAUDIO",
  "provinciaNascita": "PG",
  "sesso": "M",
  "impiego": "1"
};

export const cloudflareToken = {
  "prodotto": 3,
  "codiceFiscale": "DLCDNL87E10F205G",
  "luogo": "Via fortezza 21 milano",
  "latitudine": 45.520070,
  "longitudine": 9.222620
};

export const invalidToken = {
  prodotto:"PP",
  nome:"Federico",
  cognome:"Asperges",
  comuneNascita:"MILANO",
  provinciaNascita:"MI",
  dataNascita:"04/02/1990",
  nazioneNascita:"ITALIA",
  codiceFiscale:"SPRFRC90B04F205Z",
  prodottoCRM:null,
  sesso:"M",
  email:"test@gmail.com",
  telefonoFisso:null,
  telefonoCell:"3356533211",
  telefono:"3356533211",
  cap:"20131",
  exception:null,
  urlRitorno:null,
  crypto:"117145115024041090065071060160203085141120244195181051062133091235086165167115094141115201205058092128245240191028012085189150229106097056009113"
};


// WEBPACK FOOTER //
// ./src/modules/mocks/token.js